import fetch,{ postFrom } from '../utils/fetch';

export function getPropBalConfigDetail(params) {
  return fetch({
    method: 'GET',
    url: '/proprietor/getPropBalConfigDetail',
    params
  })
}


export function getPropBalConfigList(params) {
  return fetch({
    method: 'GET',
    url: '/proprietor/getPropBalConfigList',
    params
  })
}

export function savePropBalConfig(params) {
  return fetch({
    method: 'POST',
    url: '/proprietor/savePropBalConfig',
    data:params
  })
}
